import { AutocompleteChangeDetails } from '@mui/material';
import { Autocomplete, Input } from '@trackman/web-shared-components';
import { ServiceTypes } from 'constants/ServiceTypes';
import { Ruleset } from 'enums/Ruleset';
import { ISelectOption } from 'interfaces/ui/ISelectOption';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useInjection } from 'services/ioc/ioc.react';
import { ContextualDataStore } from 'stores/ContextualDataStore';
import { LineupStore } from 'stores/LineupStore';
import { SessionStore } from 'stores/SessionStore';
import { Body, DialogFooter, GameRow, OrganizationSubtitle, StyledButton, StyledModal } from './BpDialogStyles';

export interface ITeamExclusiveOptions {
  leagueId: string;
  leagueName: string;
  gameLevelId: string;
  gameLevelName: string;
}

interface IProps {
  visible: boolean;
  dismissCallback: () => void;
  organizations: ISelectOption[];
}

export const BpDialog: React.FC<IProps> = observer((props) => {
  const { visible, dismissCallback, organizations } = props;
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);
  const contextualDataStore = useInjection<ContextualDataStore>(ServiceTypes.ContextualDataStore);
  const history = useHistory();

  useEffect(() => {
    if (!visible) {
      return;
    }
    lineupStore.setLeague({});
    lineupStore.setGameLevel({});
    lineupStore.setOwningOrganization({});
    lineupStore.setRuleset(Ruleset.battingPractice);
  }, [visible]);

  const handleOnClick = async () => {
    sessionStore.setInitialMetadata({
      externalSessionId: '',
      privateSession: true,
    });

    document.body.style.overflow = ''; // crappy fix because Modal sets overflow to 'hidden' programatically
    // and then it doesn't have a chance to set it back to ''
    contextualDataStore.setIsBpDialogVisible(false);
    history.push('/set-lineup-bp');
  };

  const getSelectValue = (value: string | undefined, array: ISelectOption[]) => {
    return array.find((obj) => obj.value === value);
  };

  return (
    <StyledModal open={visible} onClose={dismissCallback} title='Create batting practice' titleCenter>
      <Body>
        <div>
          <GameRow>
            <Autocomplete
              value={getSelectValue(lineupStore.owningOrganization.id, organizations)?.label}
              onChange={(_1, _2, _3, newValueOption: AutocompleteChangeDetails<{ label: string; value: string }> | undefined): void => {
                if (newValueOption) {
                  lineupStore.setOwningOrganization({
                    id: newValueOption.option.value,
                    name: newValueOption.option.label,
                  });
                }
              }}
              options={[{ value: '', label: '---' }, ...organizations]}
              width='100%'
              renderInput={(params) => <Input {...params} label='Organization' />}
              disableClearable
            />
            <OrganizationSubtitle>The CSV file will be sent to the email associated with the selected organization</OrganizationSubtitle>
          </GameRow>
        </div>
        <DialogFooter>
          <StyledButton intent='primary' label='Create and set lineup' onClick={handleOnClick} width='208px' data-test='create-bp-button' />
        </DialogFooter>
      </Body>
    </StyledModal>
  );
});
